import TextYogaMeta from './TextYogaMeta'

export default TextYogaMeta
// eslint-disable-next-line import/export
export * from './TextYogaMeta'
